export default __webpack_public_path__ + "static/media/header_logo.1e594f7c.svg";